<template>
	<Container :canBackTop='!isApp'>
		<TopBar v-if='!isApp' class="tabbr"/>
		<h2 v-if='article.Title && !isApp' class="article-title">{{article.Title}}</h2>
		<div v-if='article.MediaType != "video"' class="content" :class='{"app-content":isApp}' v-html='Content'></div>
		<div class="video" v-else>
			<iframe  :src='"https://player.youku.com/embed/"+article.Link + "?client_id=006644816334a836"' style="width: 100%;height:100%"   frameborder=0 allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
		</div>
		
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import {observeMixin} from '@/components/common/mixin'
	import {baseUrl} from '@/config/env'
	export default {
		data() {
			return {
				article:{},
				clientWidth:document.body.clientWidth,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				this.initData()
			},
		},
		mixins:[observeMixin],
		components: {
			TopBar
		},
		computed: {
			...mapState({

			}),
			isApp(){
				return navigator.userAgent.indexOf('com.doterra.app') != -1
			},
			Content(){
				let content = this.article.Content
				if (this.clientWidth < 768 && this.article.ExtStr2) {
					content = this.article.ExtStr2
				}
				return this.isApp ? content : content.replace(/app:\/\/GeneralStatic/g,`${baseUrl}/client/index.html#/show/guide/detail`)
			}
		},
		methods: {
			...mapActions([
				'getCommunityArticleAction',
			]),
			async initData(){
				let Code = this.$route.query?.code
				this.article = await this.getCommunityArticleAction({Code})
				this.appAction('setTitle',{title:this.article.Title})
				this.observe(Code)
				window.addEventListener('resize', ()=>{
					this.clientWidth = document.body.clientWidth
				})
			},
			appAction(action,params) {
				if (this.isApp) {
				    let data = JSON.stringify({params,action})
				    window.postMessage(data)
				}
			},
		},
	}
</script>

<style lang='scss' scoped>
	.article-title {
		max-width: 1200px;
		margin: auto;
		padding: 20px 0;
		width: 80vw;
		// border-bottom: 1px solid #ccc;
	}
	.content {
		max-width: 1200px;
		width: 80vw;
		margin:auto;
	}
	.video {
		margin:30px auto;
		max-width: 1044px;
		max-height: 587px;
		width:80vw;
		height:45vw;
	}
	.app-content {
		width:100vw;
	}
	@media (max-width:1200px ) {
		.content {
			width: 100vw;
		}
	}
	@media (min-width:1200px ) {
		.tabbr {
			padding-left: calc(50% - 600px)
		}
	}
</style>